import React, { Component } from 'react';
import { Animate } from 'react-simple-animate';
import PortalUnit from './portal-unit.jsx';
export default class PortalUnitTable extends Component {
  constructor(props) {
    super(props);
    this.state = {
      text: props.initialValue || 'placeholder',
      portal_units: props.portal_units || null,
      isLoading: props.portal_units ? false : true,
      url: props.url || null,
      play: false
    };
  }
  getPortalUnits() {
    if (this.state.url !== null) {
      return fetch(this.state.url, {
        method: "GET",
        mode: "cors",
        cache: "no-cache",
        credentials: "same-origin",
        headers: {
          "Authorization": 'Bearer ' + window.api_token
          , "Accept": 'application/json'
        },
      }).then((responseText) => {
        let response = responseText.json();
        response.then((portalAccountsJson) => {
          this.setState({
            portal_units: portalAccountsJson,
            isLoading: false
          })
        });
      });
    }
    return false;
  }
  componentDidMount() {
    if (!this.state.portal_units) {
      this.getPortalUnits();
    }
    this.setState({
      play: true
    });
  }
  render() {
    let PortalUnitsTable = [];
    if (this.state.portal_units && this.state.portal_units.length > 0) {
      this.state.portal_units.forEach(function (i) {
        if (i && i.id) {
          PortalUnitsTable.push(
            <PortalUnit
              key={'portal-unit-id-' + i.id}
              data={i}
            />
          );
        }
      });
    }
    else {
      PortalUnitsTable = this.props.message_if_none;
    }
    return (
      <Animate
        play={this.state.play}
        start={{ opacity: 0 }}
        end={{ opacity: 1 }}
      >
        <div className="portal-admin-table">

          <div className="portal-admin-table-row header">
            <div className="cell column-type-unit-id">#</div>
            <div className="cell column-type-company1">Company</div>
            <div className="cell column-type-unit_name">Unit Name</div>
            <div className="cell column-type-unit_total_qty_per_yard">Total Qty</div>
            <div className="cell column-type-yard">Yard</div>
            <div className="cell column-type-cleaned_unit_per_yard">Cleaned Unit Qty</div>
            <div className="cell column-type-dirty_unit_per_yard">Dirty Unit Qty</div>
            <div className="cell column-type-created-at">Created at </div>
            <div className="cell column-type-last-updated">Last Updated</div>
            <div className="cell column-type-full-details"></div>
          </div>
          {
            this.state.isLoading ?
              (<div className="loading-box">
                <span className="add-loading-text">
                  <i className="fa fa-spinner fa-pulse"></i>
                </span>
              </div>) :
              PortalUnitsTable
          }
        </div>
      </Animate>
    );
  }
}

